/* Hack for legacy code */
import { DataView } from "@me8eon/data_views";

export function needOffice(v: DataView<any, any>) {
    return v.needsOffice;
}